import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import { reactQueryClient } from '../../../web/ReactQueryProvider';

const USER_LEV_ADMIN_GROUPS_QUERY_KEY = 'user-operations/user-levAdminGroups';

export function useGetUserLevAdminGroups(userId: string) {
	const userSession = useAdminUserSession();

	return useQuery({
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<string[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `admin/userOperations/${userId}/levAdminGroups`,
				}),
				'GET'
			);
		},
		queryKey: [USER_LEV_ADMIN_GROUPS_QUERY_KEY, userId],
		enabled: !!userId,
	});
}

export const invalidateUserLevAdminGroups = (userId: string) =>
	reactQueryClient.invalidateQueries({ queryKey: [USER_LEV_ADMIN_GROUPS_QUERY_KEY, userId] });
